import VerificationCoverageModal from './VerificationCoverageModal';
import Button from '../../../components/Button';
import useModal from '../../../hooks/useModal';
import { Container } from 'react-bootstrap';

const VerificationCoverageModalDemo = () => {
  const [
    showVerificationCoverageModal,
    handleShowVerificationCoverageModal,
    handleCloseVerificationCoverageModal,
  ] = useModal();

  return (
    <Container>
      <h4>Verification Coverage Modal</h4>
      <Button onClick={handleShowVerificationCoverageModal}>
        Verification Coverage Modal
      </Button>

      <VerificationCoverageModal
        showVerificationCoverageModal={showVerificationCoverageModal}
        handleCloseVerificationCoverageModal={
          handleCloseVerificationCoverageModal
        }
      />
    </Container>
  );
};

export default VerificationCoverageModalDemo;
